"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Suspended;
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("web/components/primitives/text"));
var primitives_1 = require("web/components/primitives");
var colors_1 = __importDefault(require("shared/constants/colors"));
var login_image_jpg_1 = __importDefault(require("assets/images/global/login-image.jpg"));
var style_scss_1 = __importDefault(require("./style.scss"));
var TYPES = {
    STAFF: 'staff',
    NON_STAFF: 'non_staff',
};
function Suspended(_a) {
    var match = _a.match;
    var userType = match.params.userType;
    var renderTitle = function () {
        switch (userType) {
            case TYPES.STAFF:
                return 'Access Suspended due to payment issue';
            case TYPES.NON_STAFF:
                return ' LifeLoop service has been paused';
            default:
                return '';
        }
    };
    var renderSubtitle = function () {
        switch (userType) {
            case TYPES.STAFF:
                return (react_1.default.createElement(react_1.default.Fragment, null, "To resume access to your LifeLoop account, your accounting team must resolve an account issue."));
            default:
                return '';
        }
    };
    var renderMessage = function () {
        switch (userType) {
            case TYPES.STAFF:
                return (react_1.default.createElement(react_1.default.Fragment, null, "Please contact LifeLoop Accounts Receivable Team for instructions on how to unlock your account - accounting@lifeloop.com or call 303-806-0797 x 4"));
            case TYPES.NON_STAFF:
                return (react_1.default.createElement(react_1.default.Fragment, null, "Please contact the community administrator for more information."));
            default:
                return '';
        }
    };
    return (react_1.default.createElement(primitives_1.FlexContainer, { flexDirection: "column", className: style_scss_1.default.layout },
        react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.container },
            react_1.default.createElement("div", { className: style_scss_1.default.scrollable },
                react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.formContainer, flexDirection: "column", justifyContent: "spaceBetween" },
                    react_1.default.createElement(primitives_1.FlexContainer, { flexDirection: "column" },
                        react_1.default.createElement(text_1.default, { size: "66", variant: "h1", bold: true, style: { color: colors_1.default.navy } }, renderTitle()),
                        react_1.default.createElement(text_1.default, { size: "36", variant: "h2", className: style_scss_1.default.subtitle }, renderSubtitle()),
                        react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.alertContainer },
                            react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.alertIconContainer, alignItems: "center" },
                                react_1.default.createElement(primitives_1.Icon, { type: primitives_1.IconType.alertTriangle, size: 30, className: style_scss_1.default.alertIcon })),
                            react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.alertTextContainer }, renderMessage()))))),
            react_1.default.createElement("div", { className: style_scss_1.default.imageContainer },
                react_1.default.createElement("img", { src: login_image_jpg_1.default, alt: "LifeLoop Public", className: style_scss_1.default.image })))));
}
